import * as internalMonacoEditor from 'monaco-editor/esm/vs/editor/editor.api';
const generateNewMonacoDecorations = highlightLocation => {
  if (highlightLocation == null) {
    return [{
      options: {},
      range: new internalMonacoEditor.Range(1, 1, 1, 1)
    }];
  }
  const hasColumnInfo = highlightLocation.columnStart != null && highlightLocation.columnEnd != null;
  return [{
    options: {
      className: 'monaco-editor-highlight',
      isWholeLine: !hasColumnInfo
    },
    range: new internalMonacoEditor.Range(highlightLocation.lineStart, highlightLocation.columnStart || 1, highlightLocation.lineEnd, highlightLocation.columnEnd || Infinity)
  }];
};
export default generateNewMonacoDecorations;